<template>
  <!-- S : layer-popup -->
  <div id="orderHistory" class="layer_section layer-area type-wide-a">
    <div class="layer_section-container">
        <div class="layer-content order-history">
            <h2 class="order-history__header">
                {{orderinfo.name}} 님의 주문내역
            </h2>

            <div class="order-history__result">
                총 <strong class="count">{{orderlist.length}}개</strong>의 주문내역이 있습니다.
            </div>

            <!-- 주문내역이 제공되지 않을 경우 -->
            <div class="order-history__nodata" v-if="orderinfo.privacy !== 'Y'">
                <p>* 해당 신규 ABO 가입  시 개인정보 제 3자 제공동의를 하지 않으셨기 때문에, 상세 주문 정보는 제공되지 않습니다.</p>
            </div>
            <!-- // 주문내역이 제공되지 않을 경우 -->
            <div class="order-history__list" v-if="orderinfo.privacy === 'Y'">
                <div class="order-history__list-item" v-for="(order, index) in orderlist" :key="index">
                    <div class="order-no">180-{{order.number}}</div>
                    <dl class="list">
                        <div class="list__row">
                            <dt class="list__title">주문날짜</dt>
                            <dd class="list__desc">{{order.date}}</dd>
                        </div>
                        <div class="list__row">
                            <dt class="list__title">주문금액</dt>
                            <dd class="list__desc">{{order.amt}} 원</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
        <div class="align-box size-auto">
            <button type="button" class="btn-modal_close" @click="$emit('layer')">확인</button>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['orderinfo', 'orderlist']
}
</script>

<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard/component/layerAboOrderHistory.vue